<template>
    <div v-if="dialog"
        class="modal-wrap d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100 m-auto">
        <div class="card border-0" ref="scrollToMe">
            <div class="card-body d-flex">
                <h3 class="my-6 me-3">Errore: {{ message }}</h3>
                <button class="btn btn-link end-0 link-body-emphasis link-underline-opacity-0"
                    @click="modalToggle({ redirect: false, dialog: false })"><span
                        class="icon-ico-close fs-4"></span></button>
        
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.modal-wrap {
    --bs-bg-opacity: 0.7;
    background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}
</style>

<script>

export default {
    name: "modalError",
    props: {
        message: String,
        dialog: Boolean
    },
    methods: {
        modalToggle(risp) {
            this.$emit("toggle", risp);
        },
        scrollToElement() {
            const el = this.$refs.scrollToMe;

            if (el) {
                // Use el.scrollIntoView() to instantly scroll to the element
                el.scrollIntoView({ behavior: 'smooth' });
            }

        }
    },
    mounted() {
        this.scrollToElement();
    }
}

</script>